import { Telemetry } from 'app/services/telemetry/Telemetry';
import {
  ISpO2Measurement,
  IVitalParameterMeasurement,
  IBloodPressureMeasurement,
  IHeartRateMeasurement,
  IECGMeasurement,
  ITemperatureMeasurement,
  IWeightMeasurement,
  TMeasurementValue,
} from 'app/types/measurement';

const createBloodPressure = (data: IBloodPressureMeasurement): TMeasurementValue =>
  ({ systolic: data.systolic, diastolic: data.diastolic });

const createHeartRate   = (data: IHeartRateMeasurement): TMeasurementValue  => data.heart_rate;
const createECG         = (data: IECGMeasurement): TMeasurementValue        => data.afib;
const createTemperature = (data: ITemperatureMeasurement): TMeasurementValue => data.temperature;
const createWeight      = (data: IWeightMeasurement): TMeasurementValue     => data.weight;
const createSpo2        = (data: ISpO2Measurement): TMeasurementValue       => data.saturation;

export const createMeasurement = (measurement: IVitalParameterMeasurement): TMeasurementValue | null => {
  const { activity_name, measurement: data } = measurement;

  switch (activity_name) {
    case 'blood_pressure': return createBloodPressure(data as IBloodPressureMeasurement);
    case 'heart_rate':     return createHeartRate(data as IHeartRateMeasurement);
    case 'ecg':            return createECG(data as IECGMeasurement);
    case 'temperature':    return createTemperature(data as ITemperatureMeasurement);
    case 'weight':         return createWeight(data as IWeightMeasurement);
    case 'spo2':           return createSpo2(data as unknown as ISpO2Measurement);
    default:
      Telemetry.event('measurement.factory.unknown_type', { domain: 'measurement', activity_name }, 'warning');
      return null;
  }
};
